<mat-horizontal-stepper class="add-menu" [class]="{'hide' : showHelp}" #stepper>{{stepper.index}}

    <!-- Menú Principal 0-->
    <mat-step [stepControl]="menuFormGroup">
        <mat-toolbar color="grey">
            <mat-toolbar-row>
                <div class="toolbar-line" fxLayout="row" fxLayoutAlign="space-between center" fxLayoutGap="16px">
                    <div class="title" fxLayout="column" fxLayoutAlign="center start">
                        <h3>{{'process.title' | transloco}}</h3>
                    </div>
                    <button mat-icon-button mat-dialog-close title="{{'common.closeBtn' | transloco}}">
                        <mat-icon class="fa-lg" fontSet="fa" fontIcon="fa-times"></mat-icon>
                    </button>
                </div>
            </mat-toolbar-row>
        </mat-toolbar>
        <mat-divider></mat-divider>
        <form [formGroup]="menuFormGroup">
            <div class="add-menu-form-body" fxLayout="column" fxLayoutAlign="center start" fxLayoutGap="16px">
                <mat-radio-group id="step0" formControlName="selectedMenu" required>
                    <mat-radio-button value="AddEmployeeFile" *ngIf="isAdministrator">
                        {{'process.manageFileNumbers.btn' | transloco}}
                    </mat-radio-button>
                    <mat-radio-button value="AddCandidate" *ngIf="isCandidateAdmin || isCandidateAdminBasic ">
                        {{'process.manageCandidates.btn' | transloco}}
                    </mat-radio-button>
                    <mat-radio-button value="AddDocumentation" *ngIf="isRRHH_LD || isGestorDocumental ">
                        {{'process.manageDocuments.btn' | transloco}}
                    </mat-radio-button>
                </mat-radio-group>
            </div>
            <div class="add-menu-form-actions">
                <button mat-button (click)="goToNextStep()" color="primary" class="btn"
                    [disabled]="menuFormGroup.invalid">{{'common.next' | transloco}}</button>
                <button mat-button mat-dialog-close>{{'common.cancelBtn' | transloco}}</button>
            </div>
        </form>
    </mat-step>

    <!-- Alta de Legajos 1-->
    <mat-step [stepControl]="addEmployeeFormGroup">
        <mat-toolbar color="grey">
            <mat-toolbar-row>
                <div class="toolbar-line" fxLayout="row" fxLayoutAlign="space-between center" fxLayoutGap="16px">
                    <div class="title" fxLayout="column" fxLayoutAlign="center start">
                        <h3>{{'process.manageFileNumbers.btn' | transloco}}</h3>
                    </div>

                    <button mat-icon-button (click)="closeDialog()" title="{{'common.closeBtn' | transloco}}">
                        <mat-icon class="fa-lg" fontSet="fa" fontIcon="fa-times"></mat-icon>
                    </button>

                </div>
            </mat-toolbar-row>
        </mat-toolbar>
        <mat-divider></mat-divider>
        <form [formGroup]="addEmployeeFormGroup" fxFlex="grow">
            <div class="add-menu-form-body" fxLayout="column" fxLayoutGap="16px">
                <mat-radio-group id="step1" formControlName="adminMode" fxLayout="column" #modeGroup="matRadioGroup">
                    <mat-radio-button value="manual">{{'process.manageFileNumbers.createIndividuallyBtn' | transloco}}</mat-radio-button>
                    <mat-radio-button value="auto">{{'process.manageFileNumbers.createInBulkBtn' | transloco}}</mat-radio-button>
                </mat-radio-group>
            </div>
            <div class="add-menu-form-actions">
                <button mat-raised-button (click)="goToNextEmployeeStep(modeGroup.value === 'manual')" color="primary"
                    class="btn" [disabled]="addEmployeeFormGroup.invalid">{{'common.next' | transloco}}</button>
                <button mat-button (click)="goToPreviousStep()">{{'common.last' | transloco}}</button>
            </div>
        </form>

    </mat-step>



    <!-- Alta Manual/Individual de Legajos 2-->
    <mat-step>
        <app-add-person *ngIf="selectedMenu === 'AddEmployeeFile'" (cancelAddPerson)="closeDialog()"
            (backAddPerson)="goToPreviousEmployeeStep()" (actionFinished)="postPersonAdded()" [person]="employee"
            [toolbartitle]="'process.manageFileNumbers.btn' | transloco" [isCandidate]="false"></app-add-person>
    </mat-step>


    <!-- Alta Automática/Masiva de Legajos 3-->
    <mat-step [stepControl]="addMassiveEmployeeFormGroup">
        <mat-toolbar color="grey" class="is-hidden">
            <mat-toolbar-row>
                <div class="toolbar-line" fxLayout="row" fxLayoutAlign="space-between center" fxLayoutGap="16px">
                    <div class="title" fxLayout="column" fxLayoutAlign="center start">
                        <h3>{{'process.manageFileNumbers.createInBulkBtn' | transloco}}</h3>
                    </div>
                    <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="8px">
                        <button mat-icon-button (click)="openHelp()" title="{{'common.helpBtn' | transloco}}">
                            <mat-icon class="fa-lg" fontSet="fa" fontIcon="fa-question-circle"></mat-icon>
                        </button>
                        <button mat-icon-button (click)="closeDialog()" title="{{'common.closeBtn' | transloco}}">
                            <mat-icon class="fa-lg" fontSet="fa" fontIcon="fa-times"></mat-icon>
                        </button>
                    </div>
                </div>
            </mat-toolbar-row>
        </mat-toolbar>
        <mat-divider></mat-divider>

        <form [formGroup]="addMassiveEmployeeFormGroup" fxFlex="grow" class="is-hidden">
            <div class="add-menu-form-body" fxLayout="column" fxLayoutGap="16px" fxLayoutAlign="center stretch">
                <h5 class="stepper-title">{{'process.uploadExcelFile' | transloco}}</h5>
                <mat-form-field fxLayout="row" fxLayoutAlign="start center" fxFlex="grow"
                    *ngIf="certificateProviders && certificateProviders.length > 0">
                    <mat-select [placeholder]="'common.company' | transloco" formControlName="selectedOuMassiveFrmCtrl"
                        required (selectionChange)="getMassiveRegisterExampleFile()">
                        <mat-option *ngFor="let ou of organizationalUnits" [value]="ou.id">
                            {{ou.name}}
                        </mat-option>
                    </mat-select>
                </mat-form-field>
                <div fxLayout="column" fxLayoutGap="16px" fxLayoutAlign="center stretch">
                    <app-upload-form canRemove="true" multipleSelection="true" acceptedExtensions=".xls, .xlsx"
                        [maxFile]="1" (filesChanged)="onFilesChanged($event)"></app-upload-form>
                    <mat-checkbox [checked]="sendWelcome" (change)="sendWelcome = !sendWelcome">{{ useSaml ? ('common.enableEmployees' | transloco) : ('common.notifyEmployee' | transloco)}}
                    </mat-checkbox>
                </div>
            </div>
            <div class="add-menu-form-actions">
                <button mat-raised-button [disabled]="disableFields || clickOnce" color="primary" (click)="upload()"
                    class="btn">{{'common.endBtn' | transloco}}</button>
                <button mat-button (click)="goToPreviousEmployeeStep()">{{'common.last' | transloco}}</button>
            </div>
        </form>
        <app-help-index [model]="helpModel" (helpFinish)="showHelp = !showHelp" *ngIf="showHelp"></app-help-index>
    </mat-step>

    <!-- Selección Alta de Candidatos 4-->
    <mat-step [stepControl]="addCandidateFormGroup">
        <mat-toolbar color="grey">
            <mat-toolbar-row>
                <div class="toolbar-line" fxLayout="row" fxLayoutAlign="space-between center" fxLayoutGap="16px">
                    <div class="title" fxLayout="column" fxLayoutAlign="center start">
                        <h3>{{'process.manageCandidates.btn' | transloco}}</h3>
                    </div>

                    <button mat-icon-button (click)="closeDialog()" title="{{'common.closeBtn' | transloco}}">
                        <mat-icon class="fa-lg" fontSet="fa" fontIcon="fa-times"></mat-icon>
                    </button>

                </div>
            </mat-toolbar-row>
        </mat-toolbar>
        <mat-divider></mat-divider>
        <form [formGroup]="addCandidateFormGroup" fxFlex="grow">
            <div class="add-menu-form-body" fxLayout="column" fxLayoutGap="16px">
                <mat-radio-group id="step1" formControlName="adminMode" fxLayout="column"
                    #modeCandidateGroup="matRadioGroup">
                    <mat-radio-button value="manual">{{'process.manageCandidates.createIndividuallyBtn' | transloco}}</mat-radio-button>
                    <mat-radio-button value="auto">{{'process.manageCandidates.createInBulkBtn' | transloco}}</mat-radio-button>
                </mat-radio-group>
            </div>
            <div class="add-menu-form-actions">
                <button mat-raised-button (click)="goToNextCandidateStep(modeCandidateGroup.value === 'manual')"
                    color="primary" class="btn" [disabled]="addCandidateFormGroup.invalid">{{'common.next' | transloco}}</button>
                <button mat-button (click)="goToPreviousStep()">{{'common.last' | transloco}}</button>
            </div>
        </form>

    </mat-step>

    <!-- Alta de Candidatos 5-->
    <mat-step>
        <app-add-person *ngIf="selectedMenu === 'AddCandidate'" (cancelAddPerson)="closeDialog()"
            [showOuSelection]="false" (backAddPerson)="resetStepper()" (actionFinished)="postPersonAdded()"
            [person]="candidate" [toolbartitle]="'process.manageCandidates.btn' | transloco" [isCandidate]="true"></app-add-person>
    </mat-step>

    <!-- Alta Automática/Masiva de Candidatos 6-->
    <mat-step [stepControl]="addMassiveCandidateFormGroup">
        <mat-toolbar color="grey" class="is-hidden">
            <mat-toolbar-row>
                <div class="toolbar-line" fxLayout="row" fxLayoutAlign="space-between center" fxLayoutGap="16px">
                    <div class="title" fxLayout="column" fxLayoutAlign="center start">
                        <h3>{{'process.manageCandidates.createInBulkBtn' | transloco}}</h3>
                    </div>
                    <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="8px">
                        <button mat-icon-button (click)="openHelp()" title="{{'common.helpBtn' | transloco}}">
                            <mat-icon class="fa-lg" fontSet="fa" fontIcon="fa-question-circle"></mat-icon>
                        </button>
                        <button mat-icon-button (click)="closeDialog()" title="{{'common.closeBtn' | transloco}}">
                            <mat-icon class="fa-lg" fontSet="fa" fontIcon="fa-times"></mat-icon>
                        </button>
                    </div>
                </div>
            </mat-toolbar-row>
        </mat-toolbar>
        <mat-divider></mat-divider>

        <form [formGroup]="addMassiveCandidateFormGroup" fxFlex="grow" class="is-hidden">
            <div class="add-menu-form-body" fxLayout="column" fxLayoutGap="16px" fxLayoutAlign="center stretch">
                <h5 class="stepper-title">{{'process.uploadExcelFile' | transloco}}</h5>
                <mat-form-field fxLayout="row" fxLayoutAlign="start center" fxFlex="grow"
                    *ngIf="certificateProviders && certificateProviders.length > 0">
                    <mat-select [placeholder]="'common.company' | transloco" formControlName="selectedOuMassiveFrmCtrl"
                        required (selectionChange)="getMassiveRegisterExampleFile()">
                        <mat-option *ngFor="let ou of organizationalUnits" [value]="ou.id">
                            {{ou.name}}
                        </mat-option>
                    </mat-select>
                </mat-form-field>
                <div fxLayout="column" fxLayoutGap="16px" fxLayoutAlign="center stretch">
                    <app-upload-form canRemove="true" multipleSelection="true" acceptedExtensions=".xls, .xlsx"
                        [maxFile]="1" (filesChanged)="onFilesChanged($event)"></app-upload-form>
                </div>
            </div>
            <div class="add-menu-form-actions">
                <button mat-raised-button [disabled]="disableFields || clickOnce" color="primary"
                    (click)="uploadCandidate()" class="btn">{{'common.endBtn' | transloco}}</button>
                <button mat-button (click)="goToPreviousCandidateStep()">{{'common.lastBtn' | transloco}}</button>
            </div>
        </form>
        <app-help-index [model]="helpModel" (helpFinish)="showHelp = !showHelp" *ngIf="showHelp"></app-help-index>
    </mat-step>

    <!-- Alta de Documentación 7-->
    <mat-step *ngIf="isRRHH_LD || isGestorDocumental ">
        <app-add-documentation (cancelAddDocumentation)="closeDialog()" (backAddDocumentation)="resetStepper()"
            (finishAddDocumentation)="closeDialogAddDocumentation()">
        </app-add-documentation>
    </mat-step>

</mat-horizontal-stepper>
